import React, { useContext, useEffect } from "react";

import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";

import styles from "./Reports.module.css";

type PredictionsAppContext = {
  setActiveSidebarTab: (tab: string, option?: string) => void;
};

const Reports: React.FC = () => {
  usePageTitle(AppStrings.REPORTS);

  const { setActiveSidebarTab } = useContext(
    AppContext,
  ) as PredictionsAppContext;

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.PREDICTIONS, "REPORTS");
  }, [setActiveSidebarTab]);

  return (
    <div className={styles.page} />
  );
};

export default Reports;
